import SdsButton from "@salesforce-ux/sds-components/src/button/button";
import css from "./button.css";

export default class FooButton extends SdsButton {
  connectedCallback() {
    super.connectedCallback();
    this.shadowRoot.innerHTML += `<style>${css}</style>`;
  }
}
